import {Vue, Component} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';
import {Mall} from 'supporter';
import { getLocalStorageMalls } from '@/utils/commonUtils';

@Component
export default class ProductListMallInfoMixin extends Vue {
  public mallInfo: Mall[] = getLocalStorageMalls();

  public get malls() : DisplayEnum[] {
    return [{ value: '', label: this.$t('PRODUCT_PRODUCTLIST_SHOPPING_MALL') as string }].concat(
      this.mallInfo.map(
          (mall: Mall): DisplayEnum => {
            return { value: mall.mallNo.toString(), label: mall.mallName };
          }
        )
    );
  }

  public get USMallNos() {
    return this.mallInfo.filter((mall: Mall): any => mall.countryCode === 'US').map((mall): any => mall.mallNo) || [];
  }
}
